import { Input as AntInput } from "antd";
import styled from "styled-components";

const StyledSearchInput = styled(AntInput.Search)`
    & .ant-btn {
        padding-inline: 3px;
    }

    & .ant-btn.ant-btn-primary {
        padding-inline: var(--ant-padding-xs);
    }
` as typeof AntInput.Search;

export const Input = Object.assign(AntInput, {
    ...AntInput,
    Search: StyledSearchInput,
});
